import { gql } from '@apollo/client'

export const singleGameOptionsFragment = gql`
  fragment SingleGameOptions on SingleGameTeamOption {
    __typename
    id
    level
    payout
    payoutMultiplier
    selected
    win
    title
    titleDisplayStrategy
  }
`

export const singleGameBountyOptionsFragment = gql`
  fragment SingleGameBountyOptions on SingleGameTeamBountyOption {
    __typename
    id
    level
    payout
    ranges {
      bountyIncrement
      bountyRange {
        title
        type
      }
      bountyTimesAchievable
      payout
      payoutMultiplier
    }
    selected
    win
    titleDisplayStrategy
  }
`

const parlayRequirementsFragment = gql`
  fragment ParlayBetItem on ParlayBetItem {
    lineType
    title
    titleDisplayStrategy
  }
`

export const singleGameTeamParlayOptionsFragment = gql`
  fragment SingleGameTeamParlayOptions on SingleGameTeamParlayOption {
    __typename
    id
    level
    payout
    payoutMultiplier
    selected
    win
    requirements {
      ...ParlayBetItem
    }
  }
  ${parlayRequirementsFragment}
`

const multiGameTeamPayoutFragment = gql`
  fragment MultiGameTeamPayouts on MultiGameTeamPayout {
    payout
    payoutMultiplier
    win
    requirements {
      goal
      requirement
    }
  }
`

export const multiGameTeamParlayOptionsFragment = gql`
  fragment MultiGameTeamParlayOptions on MultiGameTeamParlayOption {
    __typename
    id
    level
    selected
    failuresAllowed
    successesRequired
    payouts {
      ...MultiGameTeamPayouts
    }
    requirements {
      ...ParlayBetItem
    }
  }
  ${multiGameTeamPayoutFragment}
  ${parlayRequirementsFragment}
`
